import {ServiceClass} from '@/decorators';
import {AnyObject} from '@/globals';
import {CreateUserViewModel, LocationModel, SiteModel, UserProfileModel} from '@/sdk';
import {BaseApi} from './base.api';

@ServiceClass()
export class TeamApi extends BaseApi {
    //
}
